import { formatCompact, formatMoney, formatNumber, formatPercent } from '../../utils/format';

/**
 * The insight metrics, in KPI order. money metrics take the currency; chart marks the ones the trend can plot
 * (CPC is left out: a day with few clicks swings it wildly).
 */
export const METRICS = [
  { id: 'spend', label: 'Spend', money: true, chart: true },
  { id: 'impressions', label: 'Impressions', chart: true },
  { id: 'clicks', label: 'Clicks', chart: true },
  { id: 'link_clicks', label: 'Link clicks', chart: true },
  { id: 'ctr', label: 'CTR', percent: true, chart: true },
  { id: 'cpc', label: 'CPC', money: true },
];

export function metricValue(values, metric) {
  const value = values?.[metric.id];
  return value == null ? null : Number(value);
}

export function formatMetric(value, metric, currency) {
  if (metric.money) return formatMoney(value, currency);
  if (metric.percent) return formatPercent(value);
  return formatNumber(value);
}

export function formatAxis(value, metric, currency) {
  if (metric.percent) return `${value}%`;
  return formatCompact(value, metric.money ? currency : null);
}
